import React from 'react';
type BrowserFrameProps = {
  url: string;
  alt: string;
  /** 16:10 screenshot, supplied at 2x. */
  src?: string;
};
export function BrowserFrame({
  url,
  alt,
  src
}: BrowserFrameProps) {
  return <div className="overflow-hidden rounded-xl border border-brand-navy/10 bg-white" data-id="element-190" data-mp="kzkv5corb5bw">
      <div className="flex items-center gap-3 border-b border-brand-navy/10 bg-[#f4f6fa] px-3 py-2.5" data-id="element-191" data-mp="g82ukpqnb6rg">
        <div className="flex shrink-0 gap-1.5" aria-hidden="true" data-id="element-192" data-mp="uwzaf8yy1o2m">
          <span className="h-2.5 w-2.5 rounded-full bg-[#ff5f57]" data-id="element-193" data-mp="uzbt5ocj02gq" />
          <span className="h-2.5 w-2.5 rounded-full bg-[#febc2e]" data-id="element-194" data-mp="pxw5doiyrhun" />
          <span className="h-2.5 w-2.5 rounded-full bg-[#28c840]" data-id="element-195" data-mp="13ygoklssjfoo" />
        </div>
        <div className="min-w-0 flex-1 truncate rounded-md bg-white px-3 py-1 text-[clamp(0.7rem,0.65rem+0.15vw,0.875rem)] font-medium text-brand-gray" data-id="element-196" data-mp="zwv68kxhm973">
          {url}
        </div>
      </div>
      <div className="relative aspect-[16/10] bg-[#eef3fa]" data-id="element-197" data-mp="31nyjzj2oc3vv">
        {src ? <img src={src} alt={alt} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover object-top" data-id="element-198" data-mp="31qb7scv458gu" /> : <div role="img" aria-label={alt} className="absolute inset-0 flex flex-col p-[7%]" data-id="element-199" data-mp="3dxnkuegh0fa5">
            <div className="flex items-center justify-between" aria-hidden="true" data-id="element-200" data-mp="3io40843uqaz5">
              <span className="h-[7%] min-h-[8px] w-[22%] rounded-full bg-brand-navy/25" data-id="element-201" data-mp="3ipx6vjegsv75" />
              <span className="flex w-[34%] justify-between" data-id="element-202" data-mp="3np9q7u64nk4z">
                <span className="h-2 w-[22%] rounded-full bg-brand-navy/10" data-id="element-203" data-mp="3rnqwkbhq4qlc" />
                <span className="h-2 w-[22%] rounded-full bg-brand-navy/10" data-id="element-204" data-mp="hz95jvbzs28" />
                <span className="h-2 w-[22%] rounded-full bg-brand-navy/10" data-id="element-205" data-mp="5hk8vwibs4g0" />
              </span>
            </div>
            <div className="mt-[9%] space-y-[3%]" aria-hidden="true" data-id="element-206" data-mp="22adr2ixvkwin">
              <span className="block h-[clamp(10px,1.4vw,22px)] w-[70%] rounded-md bg-brand-navy/20" data-id="element-207" data-mp="22c71887p5yve" />
              <span className="block h-[clamp(10px,1.4vw,22px)] w-[50%] rounded-md bg-brand-navy/20" data-id="element-208" data-mp="27arypzvke4g5" />
              <span className="mt-[4%] block h-2 w-[60%] rounded-full bg-brand-navy/10" data-id="element-209" data-mp="1v6nqqdh2frw9" />
            </div>
            <span aria-hidden="true" className="mt-[6%] block h-[clamp(14px,1.8vw,30px)] w-[24%] rounded-full bg-brand-blue/60" data-id="element-210" data-mp="2965jt51e9rbf" />
          </div>}
      </div>
    </div>;
}